import * as server from '../entries/pages/dokumenty/_page.server.ts.js';

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/dokumenty/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/dokumenty/+page.server.ts";
export const imports = ["_app/immutable/nodes/8.C8IJ7Uqn.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/CpR9_xLq.js"];
export const stylesheets = [];
export const fonts = [];
